import { LocalStorage } from './constants'

export function getBrowserLocales(options = {}) {
  const defaultOptions = {
    languageCodeOnly: false,
  }

  const opt = {
    ...defaultOptions,
    ...options,
  }

  const browserLocales =
    navigator.languages === undefined
      ? [navigator.language]
      : navigator.languages

  if (!browserLocales) {
    return undefined
  }

  return browserLocales.map((locale) => {
    const trimmedLocale = locale.trim()

    return opt.languageCodeOnly ? trimmedLocale.split(/-|_/)[0] : trimmedLocale
  })
}

export const setUserLocale = (): void => {
  const userLocale = localStorage.getItem(LocalStorage.LOCALE)

  if (!userLocale || userLocale === 'null') {
    // fallback to browser locale
    const browserLocale = getBrowserLocales({ languageCodeOnly: true })
    localStorage.setItem(LocalStorage.LOCALE, browserLocale[0] || 'en')
  }
}
